module.exports = __webpack_public_path__ + "static/media/NA-MX5.fe527bf8.jpg";